import React from "react";
import logo from "../images/logo.png";
import penImage from "../images/penImage.png";

const rows = [
    {
        phase: "Starting Dose",
        dose: "2.5 mg",
        stripBg: "#F5F7FF",
        weeks: [
            { label: "Week 1", weekBg: "#9CA3AF" },
            { label: "Week 2", weekBg: "#9CA3AF" },
            {
                label: "Week 3",
                weekBg: "#9CA3AF",
                sub: "Request next pen",
                subColor: "#6D28D9",
            },
            {
                label: "Week 4",
                weekBg: "#9CA3AF",
                sub: "Pen 1 finished",
                subColor: "#6B7280",
            },
        ],
    },
    {
        phase: "",
        dose: "5 mg",
        stripBg: "#FDF2FF",
        weeks: [
            { label: "Week 5", weekBg: "#4B5563" },
            { label: "Week 6", weekBg: "#4B5563" },
            {
                label: "Week 7",
                weekBg: "#4B5563",
                sub: "Request next pen",
                subColor: "#6D28D9",
            },
            {
                label: "Week 8",
                weekBg: "#4B5563",
                sub: "Pen 1 finished",
                subColor: "#6B7280",
            },
        ],
    },
    {
        phase: "",
        dose: "7.5 mg",
        stripBg: "#E6FFF7",
        weeks: [
            { label: "Week 9", weekBg: "#059669" },
            { label: "Week 10", weekBg: "#059669" },
            {
                label: "Week 11",
                weekBg: "#059669",
                sub: "Request next pen",
                subColor: "#6D28D9",
            },
            {
                label: "Week 12",
                weekBg: "#059669",
                sub: "Pen 1 finished",
                subColor: "#6B7280",
            },
        ],
    },
    {
        phase: "",
        dose: "10 mg",
        stripBg: "#FFE8F4",
        weeks: [
            { label: "Week 13", weekBg: "#EC4899" },
            { label: "Week 14", weekBg: "#EC4899" },
            {
                label: "Week 15",
                weekBg: "#EC4899",
                sub: "Request next pen",
                subColor: "#6D28D9",
            },
            {
                label: "Week 16",
                weekBg: "#EC4899",
                sub: "Pen 1 finished",
                subColor: "#6B7280",
            },
        ],
    },
    {
        phase: "",
        dose: "12.5 mg",
        stripBg: "#FFF4E0",
        weeks: [
            { label: "Week 17", weekBg: "#1b88b3" },
            { label: "Week 18", weekBg: "#1b88b3" },
            {
                label: "Week 19",
                weekBg: "#1b88b3",
                sub: "Request next pen",
                subColor: "#6D28D9",
            },
            {
                label: "Week 20",
                weekBg: "#1b88b3",
                sub: "Pen 1 finished",
                subColor: "#6B7280",
            },
        ],
    },
    {
        phase: "Maintain Dose",
        dose: "15 mg",
        stripBg: "#FFECEC",
        weeks: [
            { label: "Week 21", weekBg: "#EF4444" },
            { label: "Week 22", weekBg: "#EF4444" },
            {
                label: "Week 23",
                weekBg: "#EF4444",
                sub: "Pen 1 finished",
                subColor: "#6D28D9",
            },
            {
                label: "Week 24",
                weekBg: "#EF4444",
                sub: "Request next pen",
                subColor: "#6B7280",
            },
        ],
    },
];

export default function DosageTimeline() {
    return (
        <div className="min-h-screen bg-white flex items-start justify-center px-4 font-poppins">

            <div className="w-full max-w-full bg-white relative">

                <h1 className="text-[32px] font-medium text-center mt-8 text-black mb-4">
                    Order Form &amp; Checkout
                </h1>

                <p className="text-[16px] font-medium text-black mb-4">
                    Mounjaro Dosage &amp; Treatment Timeline
                </p>

                <div className="bg-[#fcf7fb] px-2 py-2 rounded-lg">
                    <div className="overflow-x-auto -mx-2 px-2">

                        <div className="min-w-[720px] space-y-3">
                            {rows.map((row, idx) => (
                                <div key={idx} className="rounded-full w-full">

                                    {row.phase && (
                                        <p className="text-[14px] pl-4 font-semibold mb-1 text-[#6b2da1]">
                                            {row.phase}
                                        </p>
                                    )}

                                    <div
                                        className="w-full rounded px-4 py-2 flex items-center gap-4"
                                        style={{ backgroundColor: row.stripBg }}
                                    >

                                        <div className="flex items-center gap-3 w-60">
                                            <div className="text-[11px] text-black">
                                                <p className="font-medium">{row.dose}</p>
                                            </div>

                                            <img
                                                src={penImage}
                                                alt="Pen"
                                                className="h-8 w-auto object-contain"
                                            />
                                        </div>

                                        <div className="rounded-full flex-1 flex items-stretch gap-2">
                                            {row.weeks.map((w, i) => (
                                                <div
                                                    key={i}
                                                    className="flex-1 flex flex-col items-center text-center"
                                                >

                                                    <div
                                                        className="w-full rounded px-2 py-2 flex items-center justify-center"
                                                        style={{ backgroundColor: w.weekBg }}
                                                    >
                                                        <span className="text-xs font-semibold text-white leading-none">
                                                            {w.label}
                                                        </span>
                                                    </div>

                                                    {w.sub && (
                                                        <span
                                                            className="text-[11px] leading-tight mt-1 opacity-90"
                                                            style={{ color: w.subColor || "#6b2da1" }}
                                                        >
                                                            {w.sub}
                                                        </span>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

